import React from "react";

import { CloseRounded, SendRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";
import { httpsCallable } from "firebase/functions";

import useFirebase from "../../../../../config/context/firebaseContext";
import useModal from "../../../../../config/context/modalContext";
import { Dev } from "../../../../../config/util/consoleUtil";

import MainSolidButton from "../../../../../components/MainSolidButton";
import { ModalTransition } from "../../../../../components/ModalTransition";
import PageHeader from "../../../../../components/PageHeader";

import TextMain from "../../../../../components/InputMain/TextMain";
import { WideDialog } from "../../../../../components/MainModalSimple/styles";

import { ModalBaseType } from "../../../../../types/common";

export default function ModalDevMessage({ onClose }: ModalBaseType) {
  const [open, setOpen] = React.useState(true);

  const { pushAlert } = useModal();

  const { functions } = useFirebase();

  const [textField, setTextField] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const handleSend = async () => {
    try {
      setLoading(true);

      const writeChatMessage = httpsCallable(functions, "writeChatMessage");

      const result = await writeChatMessage({ message: textField });

      pushAlert({
        type: "success",
        message: "Mensagem Enviada",
      });

      handleClose(true);
    } catch (error) {
      console.log(...new Dev("handleSend", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao enviar mensagem",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (reload?: boolean) => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose(reload);
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={() => handleClose()}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={"Mensagem para o Dev"}
          rightIcon={<CloseRounded />}
          onRightAction={() => handleClose()}
        />

        <TextMain
          lines={3}
          name="Mensagem"
          textColor="regular"
          value={textField}
          onChange={setTextField}
        />

        <Box mt={1} mb={3}>
          <MainSolidButton
            loading={loading}
            text="Enviar"
            icon={<SendRounded />}
            onClick={handleSend}
          />
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
